import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Container,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import AppMenu from '../components/AppMenu';
import EventList, { Event } from '../components/EventList';
import { getRecommendedEvents } from '../services/eventService';
import { BASE_URL } from '../config';
import LoginModal from '../components/LoginModal';
import SignupModal from '../components/SignupModal';


const RecommendedEvents = () => {
  const [events, setEvents] = useState<Event[]>([]);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isSignupOpen, setIsSignupOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  


  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const data = await getRecommendedEvents();
      setEvents(data);
    } catch (error) {
      console.error('Error fetching recommended events:', error);
    }
  };

  const handleEventClick = (event: Event) => {
    navigate(`/events/${event.id}`);
  };

  const handleLoginClick = () => {
    setIsLoginOpen(true);
  };

  const handleSignupClick = () => {
    setIsSignupOpen(true);
  };

  const handleSwitchToSignup = () => {
    setIsLoginOpen(false);
    setIsSignupOpen(true);
  };

  const handleSwitchToLogin = () => {
    setIsSignupOpen(false);
    setIsLoginOpen(true);
  };

  return (
    <Box width="100vw" overflow="hidden">
      <AppMenu 
        currentPath={location.pathname}
        onLoginClick={handleLoginClick}
        onSignupClick={handleSignupClick}
      />
      
      <Container maxWidth="lg">
        <Box sx={{ p: 3 }}>
          <Box 
            sx={{ 
              display: 'flex', 
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'space-between', 
              alignItems: { xs: 'flex-start', sm: 'center' },
              mb: 4,
              borderBottom: '1px solid',
              borderColor: 'divider',
              pb: 2,
              gap: { xs: 2, sm: 0 }
            }}
          >
            <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
              <Typography 
                variant="h4" 
                component="h1"
                sx={{ 
                  fontWeight: 700,
                  color: 'primary.main',
                  mb: 0.5,
                  fontSize: { xs: '1.75rem', sm: '2rem', md: '2.25rem' }
                }}
              >
                Recommended Events
              </Typography>
              <Typography 
                variant="body1" 
                color="text.secondary"
                sx={{ 
                  fontSize: { xs: '0.85rem', sm: '0.9rem' },
                  maxWidth: { xs: '80%', sm: 'none' }
                }}
              >
                Discover popular events you might like
              </Typography>
            </Box>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => navigate('/create-event')}
              sx={{ 
                textTransform: 'none',
                px: { xs: 3, sm: 2 },
                py: { xs: 1.5, sm: 1 },
                width: { xs: '100%', sm: 'auto' },
                mt: { xs: 1, sm: 0 },
                fontSize: { xs: '0.9rem', sm: '0.875rem' }
              }}
            >
              Create Event
            </Button>
          </Box>

          <EventList 
            events={events}
            onEventClick={handleEventClick}
            baseUrl={BASE_URL}
          />
        </Box>
      </Container>

      <LoginModal
        open={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
        onSwitchToSignup={handleSwitchToSignup}
        redirectPath={location.pathname}
      />

      <SignupModal
        open={isSignupOpen}
        onClose={() => setIsSignupOpen(false)}
        onSwitchToLogin={handleSwitchToLogin}
      />

    </Box>
  );
};

export default RecommendedEvents; 